import React, { Component } from 'react'
import { AutoComplete, Select, Icon, Button } from 'antd';
import { connect } from 'react-redux';
import { getSupplies } from '../redux/actions/supply';

const Option = AutoComplete.Option;
const SelectOption = Select.Option;

function formatPrice(v) {
    return `$${Number(v || 0).toFixed(2)}`;
}

function variantOptionText(v) {
    return v.optionLabel ? `${v.optionLabel} — ${formatPrice(v.price)}` : formatPrice(v.price);
}

// Picks which Supply variants are offered this Sprouts round — modeled on
// SupplyIngredientPicker.jsx's search/pick/add flow, but simpler: a round
// item is just "offered or not," there's no per-item quantity like a kit's
// bill-of-materials. Whether a picked item displays as yarn or an add-on in
// the mobile modal is derived server-side from its Supply category, not
// chosen here — this picker is one flat list.
class SproutsItemPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            query: '',
            results: [],
            pendingSupply: null,
            pendingVariantId: '',
        };
    }

    handleSearch = (q) => {
        this.setState({ query: q, pendingSupply: null, pendingVariantId: '' });
        if (!q || !q.trim()) {
            this.setState({ results: [] });
            return;
        }
        this.props.dispatch(getSupplies({ search: q.trim(), length: 20 })).then(res => {
            let matches = (res && res.data && res.data.data) || [];
            this.setState({ results: matches });
        }).catch(() => {
            this.setState({ results: [] });
        })
    }

    handleSelectSupply = (val, option) => {
        let supply = JSON.parse(option.props.value);
        let variants = supply.variants || [];
        let autoVariantId = variants.length === 1 ? variants[0]._id : '';
        this.setState({ pendingSupply: supply, pendingVariantId: autoVariantId, query: supply.name, results: [] });
    }

    handleAdd = () => {
        let { pendingSupply, pendingVariantId } = this.state;
        if (!pendingSupply || !pendingVariantId) return;
        let variant = (pendingSupply.variants || []).find(v => v._id === pendingVariantId);
        if (!variant) return;
        let { value, onChange } = this.props;
        let current = value || [];
        if (current.some(item => item.variantId === variant._id)) {
            this.setState({ pendingSupply: null, pendingVariantId: '', query: '', results: [] });
            return; // already added
        }
        onChange([...current, {
            supplyId: pendingSupply._id,
            variantId: variant._id,
            name: variant.optionLabel ? `${variant.optionLabel} — ${pendingSupply.name}` : pendingSupply.name,
            price: variant.price,
            image: variant.image || (pendingSupply.images && pendingSupply.images[0]) || null,
            categoryId: pendingSupply.categoryId,
        }]);
        this.setState({ pendingSupply: null, pendingVariantId: '', query: '', results: [] });
    }

    handleRemove = (index) => {
        let { value, onChange } = this.props;
        let updated = (value || []).slice();
        updated.splice(index, 1);
        onChange(updated);
    }

    render() {
        let { query, results, pendingSupply, pendingVariantId } = this.state;
        let items = this.props.value || [];
        let multiVariant = pendingSupply && (pendingSupply.variants || []).length > 1;
        let singleVariant = pendingSupply && (pendingSupply.variants || []).length === 1 ? pendingSupply.variants[0] : null;

        return (
            <div className="sprouts-item-picker">
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                    <AutoComplete
                        style={{ width: 260, fontSize: 16 }}
                        value={query}
                        onSearch={this.handleSearch}
                        onSelect={this.handleSelectSupply}
                        onChange={(v) => this.setState({ query: v })}
                        placeholder="Search supplies…"
                    >
                        {results.map(s => (
                            <Option key={s._id} value={JSON.stringify(s)}>{s.name}</Option>
                        ))}
                    </AutoComplete>
                    {multiVariant && (
                        <Select
                            style={{ width: 220, fontSize: 16 }}
                            placeholder="Variant"
                            value={pendingVariantId || undefined}
                            onChange={(v) => this.setState({ pendingVariantId: v })}
                        >
                            {pendingSupply.variants.map(v => (
                                <SelectOption key={v._id} value={v._id}>{variantOptionText(v)}</SelectOption>
                            ))}
                        </Select>
                    )}
                    {singleVariant && (
                        <span style={{ fontSize: 16, color: '#494d4b', whiteSpace: 'nowrap' }}>{variantOptionText(singleVariant)}</span>
                    )}
                    {pendingSupply && pendingVariantId && (
                        <Button type="primary" style={{ fontSize: 16 }} onClick={this.handleAdd}>
                            Add
                        </Button>
                    )}
                </div>
                {items.length > 0 && (
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 16, marginBottom: 16 }}>
                        <tbody>
                            {items.map((item, i) => {
                                let cellStyle = { padding: '18px 16px 18px 0', fontSize: 16, fontWeight: 400, color: '#494d4b', verticalAlign: 'top', borderBottom: '1px solid #eee' };
                                return (
                                    <tr key={item.variantId}>
                                        <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>{item.name}</td>
                                        <td style={{ ...cellStyle, whiteSpace: 'nowrap' }}>{formatPrice(item.price)}</td>
                                        <td style={{ ...cellStyle, textAlign: 'right', width: 32 }}>
                                            <Icon
                                                type="minus-circle-o"
                                                className="dynamic-delete-button"
                                                style={{ cursor: 'pointer', position: 'static' }}
                                                onClick={() => this.handleRemove(i)}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>
        );
    }
}

export default connect()(SproutsItemPicker);
